import { render, staticRenderFns } from "./BTableCommon.vue?vue&type=template&id=924909ea&"
import script from "./BTableCommon.vue?vue&type=script&lang=js&"
export * from "./BTableCommon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports